/** Walls 3 m high under a flat roof. */
export const VILLA_WALL_HEIGHT = 3;
/** The rooms in the order of the side lectern's buttons, two rows of three. */
export const VILLA_ROOM_ORDER = [
    'woonkamer',
    'keuken',
    'hal',
    'slaapkamer',
    'garage',
    'terras',
];
export const VILLA_ROOMS = {
    // Glass on the sea and west sides.
    woonkamer: {
        name: 'Woonkamer',
        rect: { x: [-12, 0], z: [-7, 0] },
        view: { pos: [-2, 0, -1], look: [-8, 1, -5] },
    },
    // Open to the living room.
    keuken: {
        name: 'Keuken',
        rect: { x: [-12, -5], z: [0, 7] },
        view: { pos: [-6, 0, 5.5], look: [-9, 1, 2] },
    },
    // The front door at z = 7.
    hal: {
        name: 'Hal',
        rect: { x: [-5, 1], z: [0, 7] },
        view: { pos: [-2, 0, 5.8], look: [-2, 1.2, 0] },
    },
    // Glass on the sea side.
    slaapkamer: {
        name: 'Slaapkamer',
        rect: { x: [0, 12], z: [-7, 0] },
        view: { pos: [1.5, 0, -1], look: [7, 1, -5] },
    },
    // A door to the hall, the garage door to the driveway; every piece starts here.
    garage: {
        name: 'Garage',
        rect: { x: [1, 12], z: [0, 7] },
        view: { pos: [1.8, 0, 3.5], look: [8, 1, 3.5] },
    },
    // A glass balustrade on the sea side.
    terras: {
        name: 'Terras',
        rect: { x: [-12, 12], z: [-12, -7] },
        view: { pos: [-4, 0, -8], look: [-4, 1.2, -40] },
    },
};
/** The garage's overflow for pieces: walkable for pieces only, no viewpoint. */
export const VILLA_DRIVEWAY = { x: [1, 12], z: [7, 15] };
export const VILLA_LAWN = { x: [12, 20], z: [0, 15] };
/** Where a piece's footprint centre may stand: the rooms, then the driveway and the lawn. */
export const VILLA_WALKABLE = [
    ...VILLA_ROOM_ORDER.map((id) => VILLA_ROOMS[id].rect),
    VILLA_DRIVEWAY,
    VILLA_LAWN,
];
/** The four photos of a result, each from a room's corner across it; the terrace's looks back at the house. */
export const VILLA_PHOTO_SPOTS = {
    woonkamer: { eye: [-0.6, 1.6, -0.6], look: [-8, 0.8, -5], fov: 70 },
    keuken: { eye: [-5.6, 1.6, 6.4], look: [-10, 0.8, 2], fov: 70 },
    slaapkamer: { eye: [0.6, 1.6, -0.6], look: [8, 0.8, -5], fov: 70 },
    terras: { eye: [0, 1.6, -11.6], look: [-2, 1.2, -3], fov: 75 },
};
/** Whether `at` ([x, z]) lies in `rect`, edges included. */
export function inRect(rect, at) {
    return at[0] >= rect.x[0] && at[0] <= rect.x[1] && at[1] >= rect.z[0] && at[1] <= rect.z[1];
}
//# sourceMappingURL=villa.js.map